
import Vue from 'vue';
import _truncate from 'lodash/truncate';
import { TeamUserMixin } from '@/mixins';
import AdminWorkspaceStats from '@/components/AdminStats/AdminWorkspaceStats.vue';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'WorkspaceCard',
	mixins: [
		TeamUserMixin,
	],
	props: {
		workspace: { type: Object, default: null },
		selected: { type: Boolean, default: false },
		selectionMode: { type: Boolean, default: false },
		// Team this card is being shown for. Omitted by callers whose context already is
		// the signed-in team (e.g. the session storage picker), which fall back to the store.
		currTeam: { type: Object, default: null },
		currTeamUserRole: { type: Object, default: null },
	},
	methods: {
		_truncate,
		handleClick () {
			if (this.selectionMode) {
				if (this.workspace) {
					this.$emit('on-select', this.workspace);
				} else {
					this.$emit('on-select', null);
				}
			}
		},
	},
	computed: {
		...mapState([
			'isAdminProxyingUser',
			'user',
		]),
		contextTeam (): any {
			return this.currTeam || this.team;
		},
		contextTeamUserRole (): any {
			return this.currTeam ? this.currTeamUserRole : this.teamUserRole;
		},
		hasContextTeamRdAdminPermission (): boolean {
			if (!this.contextTeam) return false;
			return this.checkRdAdminPermission(this.contextTeam, this.contextTeamUserRole);
		},
		isContextTeamActive (): boolean {
			return !!this.contextTeam?.isActive;
		},
	},
	components: {
		AdminWorkspaceStats,
	}
});
